import { NgModule } from '@angular/core';
import { CookiesStorageService, LocalStorageService, SessionStorageService, SharedStorageService } from './service/index';
export { CookieStorage, LocalStorage, SessionStorage, SharedStorage, SharedStorage as TempStorage } from './decorator/webstorage';
export { WebStorageService, CookiesStorageService, LocalStorageService, SessionStorageService, SharedStorageService, SharedStorageService as TempStorageService } from './service/index';
export { NgxStorageEvent } from './utility/storage/storage-event';
export { Resource as NgxResource } from './service/resource';
var WebStorageModule = /** @class */ (function () {
    function WebStorageModule() {
    }
    WebStorageModule.decorators = [
        { type: NgModule, args: [{
                    providers: [
                        LocalStorageService,
                        SessionStorageService,
                        CookiesStorageService,
                        SharedStorageService,
                    ]
                },] },
    ];
    return WebStorageModule;
}());
export { WebStorageModule };
//# sourceMappingURL=ngx-store.js.map